export default __webpack_public_path__ + "static/media/full-mode.6c9cc390.svg";